module.exports = __webpack_public_path__ + "static/media/cloud-snow.bb1a3035.svg";